import { spawn } from "redux-saga/effects";

import {
  updateGlTipApplicationIdSaga,
  updateGlTipAuthDataSaga,
  updateGlTipContactIdSaga,
  updateGlTipIsFirstApplicationSaga,
  updateGlTipIsNewApplicationSaga,
  updateGlTipIsShortFormSaga,
} from "./updateGlTipContextSaga";
// eslint-disable-next-line import/no-cycle
import updateLastStepSaga from "./updateLastStepSaga";
import updateYandexClientSaga from "./updateYandexClientSaga";

// TODO:: После того, как поменяем архитектуру приложения, настроить линтер на дефолтный экспорт для саг
// eslint-disable-next-line import/no-default-export
export default function* sagas() {
  yield spawn(updateLastStepSaga);
  yield spawn(updateYandexClientSaga);
  yield spawn(updateGlTipApplicationIdSaga);
  yield spawn(updateGlTipIsFirstApplicationSaga);
  yield spawn(updateGlTipIsNewApplicationSaga);
  yield spawn(updateGlTipContactIdSaga);
  yield spawn(updateGlTipAuthDataSaga);
  yield spawn(updateGlTipIsShortFormSaga);
}
